import React, { Component } from 'react';
import Circular from '../Circular/Circular';
import Table from 'components/Table/Table';
import { getAllEvents } from '../../services/events/events';
import { addHours, format } from 'date-fns'


class Events extends Component {
  constructor(props) {
    super(props);
    this.getEvents = this.getEvents.bind(this);
    this.state = {
      circular: true,
      events: [],
    };
  }

  componentDidMount() {
    this.getEvents(this.props.lockerId);
  }

  getEvents = (lockerId) => {
    let { events } = this.state;

    getAllEvents(lockerId, (data) => {
      if (data.length == 0) {
        events = ['Nenhum evento encontrado'];

        this.setState({ events, circular: false });
      } else {
        events = data.length > 0 ? [] : events;
        console.log(data);
        data.data.forEach((event) => {
          let { code, complemento, parametro1, createdAt } = event;
          events.push([
            code ? code : '-',
            complemento ? complemento : '-',
            parametro1 ? parametro1 : '-',
            createdAt ?
              format(addHours(new Date(createdAt), 3), "dd/MM/yy HH:mm:ss") :
              '-',
          ]);
        });
      }

      this.setState({ events, circular: false });
    });
  };

  render() {
    const { circular } = this.state;
    let layout;

    layout = circular ? (
      <Circular />
    ) : (
      <Table
        tableHeaderColor="primary"
        tableHead={['Id', 'Evento', 'Porta', 'Gerado em']}
        tableData={this.state.events}
      />
    );

    return <div>{layout}</div>;
  }
}
export default Events;
